import { render, staticRenderFns } from "./breed_segment_page.vue?vue&type=template&id=5f4f93d1&scoped=true"
import script from "./breed_segment_page.vue?vue&type=script&lang=js"
export * from "./breed_segment_page.vue?vue&type=script&lang=js"
import style0 from "./breed_segment_page.vue?vue&type=style&index=0&id=5f4f93d1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4f93d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f4f93d1')) {
      api.createRecord('5f4f93d1', component.options)
    } else {
      api.reload('5f4f93d1', component.options)
    }
    module.hot.accept("./breed_segment_page.vue?vue&type=template&id=5f4f93d1&scoped=true", function () {
      api.rerender('5f4f93d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/breed_segment_page.vue"
export default component.exports